
import { getSinglePage } from '../lib/storyblok/graphql';
import SliceContent from '../components/SliceContent';
import { useRouter } from 'next/router';
import Layout from '../components/Layout';

export default function Page({document}) {
    const router = useRouter();
    const currentRoute = router.pathname;
    const { 
        seo_title,
        seo_image, 
        seo_description, 
        seo_type, 
        seo_canonical,
        seo_video,
        seo_audio
      } = document.content;
      
    return (
        <>
            <Layout
                currentRoute={currentRoute}
                title={seo_title}
                image={seo_image}
                description={seo_description}
                type={seo_type}
                canonical={seo_canonical}
                audio={seo_audio}
                video={seo_video}
            >
                <SliceContent content={document.content.body} />
            </Layout>
        </>
    )
}

export async function getServerSideProps(context) {
    const document = await getSinglePage(context.query.snug); 


    return {
      props: {
        document: document,
      }, // will be passed to the page component as props
    }
  }